import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const MultiLineSkeleton = () => (
  <Box className={styles['skeleton__column--multi']}>
    <SkeletonComponent height="18px" width="90%" />
    <SkeletonComponent height="18px" width="75%" />
    <SkeletonComponent height="18px" width="60%" />
  </Box>
);

const TableSkeletonGiveaway = () => (
  <Box className={styles['table-skeleton__container']}>
    <Table className={styles['table__skeleton']}>
      <Thead>
        <Tr>
          <Th className={styles['skeleton__head']} minWidth="120px">
            <SkeletonComponent height="18px" width="70%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="242px">
            <SkeletonComponent height="18px" width="50%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="350px">
            <SkeletonComponent height="18px" width="40%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="79px">
            <SkeletonComponent height="18px" width="60%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="130px">
            <SkeletonComponent height="18px" width="70%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="100px">
            <SkeletonComponent height="18px" width="50%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="120px">
            <Flex justifyContent="center">
              <SkeletonComponent height="18px" width="50%" />
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4, 5]}
          render={(num) => (
            <Tr key={num}>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="18px" width="80%" mb="6px" />
                <SkeletonComponent height="18px" width="60%" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="18px" width="85%" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <MultiLineSkeleton />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <MultiLineSkeleton />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <MultiLineSkeleton />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="24px" width="70%" borderRadius="4px" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <Flex justifyContent="center" gap="10px">
                  <SkeletonComponent height="32px" width="32px" borderRadius="4px" />
                  <SkeletonComponent height="32px" width="32px" borderRadius="4px" />
                </Flex>
              </Td>
            </Tr>
          )}
        />
      </Tbody>
    </Table>
  </Box>
);

export default TableSkeletonGiveaway;
